import { Injectable } from "@angular/core";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import {
  PRIMITIVE,
  ServiceMessageBroker,
  ServiceMessageBrokerFactory,
} from "shared/provider-webworker";

import { BfxBlotterOrdersContextMenuForceTakeItem } from "../../../../model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuForceTakeItem";
import { BfxBlotterOrdersContextMenuTakeItem } from "../../../../model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuTakeItem";
import { BaseLookupService } from "../../../../lookup/impl/BaseLookupService";
import { BfxBlotterAction } from "../../../../model/contextmenu/bfx-base-blotter/BfxBlotterAction";
import { BfxBlotterOrdersContextMenuAcceptanceItem } from "../../../../model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuAcceptanceItem";
import { BfxBlotterOrdersContextMenuCancelItem } from "../../../../model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuCancelItem";
import { BfxBlotterOrdersContextMenuItem } from "../../../../model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuItem";
import { BfxBlotterOrdersContextMenuQuickFillItem } from "../../../../model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuQuickFillItem";
import { BfxBlotterOrdersContextMenuState } from "../../../../model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuState";
import { BfxBlotterOrdersContextMenuTransferAbortItem } from "../../../../model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuTransferAbortItem";
import { BfxBlotterOrdersContextMenuTransferItem } from "../../../../model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuTransferItem";
import { ContextMenuItem } from "../../../../model/contextmenu/ContextMenuItem";
import { ContextMenuItemState } from "../../../../model/contextmenu/ContextMenuItemState";
import { ContextMenuItemStateCommandCriteria } from "../../../../model/contextmenu/ContextMenuItemStateCommandCriteria";
import { ContextMenuServiceResponse } from "../../../../model/contextmenu/ContextMenuServiceResponse";
import { OrderDataPromiseLookupService } from "../../../../lookup/model/impl/OrderDataPromiseLookupService";

import {
  FIND_ORDERS_CONTEXT_MENU_SERVICE,
  IFindOrdersContextMenuService,
} from "../IFindOrdersContextMenuService";
import { BfxFindOrdersContextMenuPromiseService } from "./BfxFindOrdersContextMenuPromiseService";
import { ActiveUser } from "../../../../model/core/ActiveUser";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class BfxFindOrdersContextMenuPrimaryService extends BfxFindOrdersContextMenuPromiseService {
  protected menuItems: Array<BfxBlotterOrdersContextMenuItem>;
  protected broker: ServiceMessageBroker;

  constructor(protected factory: ServiceMessageBrokerFactory) {
    super();
    this.broker = this.factory.createMessageBroker(FIND_ORDERS_CONTEXT_MENU_SERVICE, true, true);

    this.broker.registerMethod(
      "getMenuItems",
      [PRIMITIVE, PRIMITIVE],
      this.getMenuItems.bind(this),
      PRIMITIVE,
    );

    let acceptanceMenuItemFactory = new BfxBlotterOrdersContextMenuAcceptanceItem.Factory();

    this.menuItems = [
      new BfxBlotterOrdersContextMenuItem(
        BfxBlotterAction.ACTION_ORDER_DUPLICATE,
        "Duplicate",
        function checkAvailable(
          menuState: BfxBlotterOrdersContextMenuState,
          itemState: ContextMenuItemState,
        ) {
          itemState.available = menuState.canEnterOrders;
        },
        function checkEnabled(
          menuState: BfxBlotterOrdersContextMenuState,
          itemState: ContextMenuItemState,
          item: CubiqTS.OrderDataImpl,
        ) {
          itemState.enabled = itemState.available && menuState.count == 1;
        },
        ContextMenuItemStateCommandCriteria.MenuItem,
        ContextMenuItemStateCommandCriteria.MenuItem,
      ),
      new BfxBlotterOrdersContextMenuItem(
        BfxBlotterAction.SEPARATOR,
        "",
        function checkAvailable(
          menuState: BfxBlotterOrdersContextMenuState,
          itemState: ContextMenuItemState,
        ) {
          itemState.available = true;
        },
        function checkEnabled(
          menuState: BfxBlotterOrdersContextMenuState,
          itemState: ContextMenuItemState,
        ) {
          itemState.enabled = false;
        },
        ContextMenuItemStateCommandCriteria.MenuItem,
        ContextMenuItemStateCommandCriteria.MenuItem,
      ),
      new BfxBlotterOrdersContextMenuItem(
        BfxBlotterAction.ACTION_VIEW_DETAILS,
        "View Details",
        function checkAvailable(
          menuState: BfxBlotterOrdersContextMenuState,
          itemState: ContextMenuItemState,
        ) {
          itemState.available = true;
        },
        function checkEnabled(
          menuState: BfxBlotterOrdersContextMenuState,
          itemState: ContextMenuItemState,
        ) {
          itemState.enabled = menuState.count == 1;
        },
        ContextMenuItemStateCommandCriteria.MenuItem,
        ContextMenuItemStateCommandCriteria.MenuItem,
      ),
      new BfxBlotterOrdersContextMenuItem(
        BfxBlotterAction.ACTION_VIEW_AUDIT,
        "View Audit Log",
        function checkAvailable(
          menuState: BfxBlotterOrdersContextMenuState,
          itemState: ContextMenuItemState,
        ) {
          itemState.available = true;
        },
        function checkEnabled(
          menuState: BfxBlotterOrdersContextMenuState,
          itemState: ContextMenuItemState,
        ) {
          itemState.enabled = menuState.count == 1;
        },
        ContextMenuItemStateCommandCriteria.MenuItem,
        ContextMenuItemStateCommandCriteria.MenuItem,
      ),
      new BfxBlotterOrdersContextMenuItem(
        BfxBlotterAction.ACTION_ORDER_RECAP,
        "Order Recap",
        function checkAvailable(
          menuState: BfxBlotterOrdersContextMenuState,
          itemState: ContextMenuItemState,
        ) {
          itemState.available = menuState.canExport;
        },
        function checkEnabled(
          menuState: BfxBlotterOrdersContextMenuState,
          itemState: ContextMenuItemState,
        ) {
          itemState.enabled = menuState.count > 0;
        },
        ContextMenuItemStateCommandCriteria.MenuItem,
        ContextMenuItemStateCommandCriteria.MenuItem,
      ),
      new BfxBlotterOrdersContextMenuItem(
        BfxBlotterAction.ACTION_EXPORT,
        "Export to CSV",
        function checkAvailable(
          menuState: BfxBlotterOrdersContextMenuState,
          itemState: ContextMenuItemState,
        ) {
          itemState.available = menuState.canExport;
        },
        function checkEnabled(
          menuState: BfxBlotterOrdersContextMenuState,
          itemState: ContextMenuItemState,
        ) {
          itemState.enabled = menuState.count > 0;
        },
        ContextMenuItemStateCommandCriteria.MenuItem,
        ContextMenuItemStateCommandCriteria.MenuItem,
      ),
    ];
  }

  public getMenuItems(
    selectedIds: Array<string>,
    menuState: BfxBlotterOrdersContextMenuState,
    selectedItems?: Array<any>,
  ): Promise<ContextMenuServiceResponse<CubiqTS.OrderDataImpl, BfxBlotterOrdersContextMenuItem>> {
    return new Promise((resolve, reject) => {
      menuState = Object.assign(new BfxBlotterOrdersContextMenuState(), menuState);
      menuState.activeUser = Object.assign(new ActiveUser(), menuState.activeUser);
      menuState.reset();

      let menuItems: Array<BfxBlotterOrdersContextMenuItem>;
      menuState.count = selectedIds.length;

      menuItems = this.menuItems.map<BfxBlotterOrdersContextMenuItem>(
        (menuItem, menuItemIndex, menuItems) => {
          menuItem.reset();

          if (ContextMenuItemStateCommandCriteria.MenuItem === menuItem.checkAvailableCriteria) {
            menuItem.checkAvailable(menuState, menuItem.state, null);
          }

          if (ContextMenuItemStateCommandCriteria.MenuItem === menuItem.checkEnabledCriteria) {
            menuItem.checkEnabled(menuState, menuItem.state, null);
          }

          return menuItem;
        },
      );

      resolve({
        menuItems: menuItems,
        menuState: menuState,
        actionDecorators: null,
      });
    });
  }

  // just a dummy
  public getMenuItemsForDataItem(
    item: CubiqTS.OrderDataImpl,
    menuState: BfxBlotterOrdersContextMenuState,
  ): ContextMenuServiceResponse<CubiqTS.OrderDataImpl, BfxBlotterOrdersContextMenuItem> {
    return { menuItems: null, menuState: null, actionDecorators: null };
  }
}
